<template>
  <div>
    <div class="flex flex-vertical-center flex-between">
      <mobile-logo-menu></mobile-logo-menu>

      <div class="flex flex-between">
        <router-link
          v-for="link in topNav"
          :key="link.to"
          :to="{ name: link.to }"
          class="mobile_header--link"
        >
          <icon-default
            class="mobile_header--link--icon"
            :icon="link.icon"
          ></icon-default>

          <badge-default
            v-if="link.badge"
            class="mobile_header--link--badge"
            :count="link.badge"
          ></badge-default>
        </router-link>

        <button-icon
          class="mobile_header--new_button"
          icon="plus"
          @click="$refs.newRecordModal.open()"
        ></button-icon>
      </div>
    </div>

    <modal-container>
      <modal-crud-form
        ref="newRecordModal"
        title="Lead"
        form-component="record-form"
        :width="600"
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import MobileLogoMenu from "./MobileLogoMenu";

export default {
  name: "MobileHeader",
  components: {MobileLogoMenu},
  computed: {
    topNav() {
      // This is not in data because the badges need to by dynamic
      return [
        {
          to: 'inbox',
          icon: 'inbox',
          label: 'Inbox',
          badge: this.inboxBadge
        },
        {
          to: 'pipeline',
          icon: 'pipeline',
          label: 'Pipeline',
          badge: null
        },
        {
          to: 'leads',
          icon: 'lead',
          label: 'Leads',
          badge: null
        },
        {
          to: 'up-next',
          icon: 'up-next',
          label: 'Up Next',
          badge: this.upNextBadge
        },
        {
          to: 'comms',
          icon: 'comms',
          label: 'Comms',
          badge: null
        },
        {
          to: 'contacts',
          icon: 'contacts',
          label: 'Contacts',
          badge: null
        },
      ]
    },
    inboxBadge() {
      return this.$store.getters.inboxBadge;
    },
    upNextBadge() {
      return parseInt(this.$store.getters.tasksBadge);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.mobile_header {

  &--link {
    position: relative;
    display: block;
    margin-right: 6px;
    // Icon size is 24px
    padding: calc((($headerHeight - 24px) / 2)) 6px;
    color: $text-light;
    text-align: center;

    &:hover {
      background-color: $background;
      border-left-color: $background;
      color: $text-muted;
    }

    &.parent {
      color: $primary!important; // want to make sure this happens even when hovering
      border-left-color: $primary!important; // want to make sure this happens even when hovering
    }

    &--badge {
      position: absolute;
      left: 40%;
      bottom: 6px; // this centers the badge with the icon
      height: 20px!important;
      min-width: 22px!important;
      border: 2px solid $white;
    }
  }

  &--new_button {
    // Icon size is 30px
    margin-top: calc(($headerHeight - 30px) / 2);
    margin-left: 20px;
    border-radius: 0;
    background-color: $primary;
    color: $white;

    &:hover {
      background-color: $secondary;
    }
  }
}
</style>
